/*
window.addEventListener("DOMContentLoaded",async()=>{
    await updateCartCounters()
   
  
  })*/

  window.addEventListener( "pageshow", (event)=> {
var historyTraversal = event.persisted || 
           ( typeof window.performance != "undefined" && 
                window.performance.navigation.type === 2 );
if ( historyTraversal ) {


//document.dispatchEvent(new CustomEvent('cart:updated'));
window.location.reload();


}
});
